import { useFlags } from 'flagsmith/react';

export function useDepositFeatureGate(): boolean {
  const { deposit_feature_gate } = useFlags(['deposit_feature_gate']);
  return deposit_feature_gate?.enabled;
}
